<div class="grid-container margin-top">
  <div class="grid-x grid-margin-x">
    <div>
      <h2>Permit Applications Monthly Tracking</h2>
    </div>
  </div>
  <div class="grid-x grid-margin-x">
    <div class="cell large-1 small-1 medium-1 text-align-right">
      <label for="fromDate">From:</label>
    </div>
    <div class="cell small-11 medium-5 large-3 date-picker-cell">
      <common-date-picker [id]="'fromDate'" (dateUpdated)="fromDateChanged($event, 'monthlyTrackingGrid')" [initialDate]="monthlyTrackingFromDate"></common-date-picker>
    </div>
    <div class="cell large-1 small-1 medium-1 text-align-right">
      <label for="toDate">To:</label>
    </div>
    <div class="cell small-11 medium-5 large-3 date-picker-cell">
      <common-date-picker [id]="'toDate'" (dateUpdated)="toDateChanged($event, 'monthlyTrackingGrid')" [initialDate]="monthlyTrackingToDate"></common-date-picker>
    </div>
    <div class="cell small-6 medium-6 large-2 vertical-align-middle">
      <button (click)="generateMonthlyTrackingReport()" [disabled]="invalidDateCombinationMonthlyTracking" class="button">
        Filter by Date
      </button>
    </div>
    <div class="cell small-6 medium-6 large-2 text-right vertical-align-middle">
      <button (click)="downloadMonthlyTrackingReport()" class="button" [disabled]="invalidDateCombinationMonthlyTracking">
        Download Report
      </button>
    </div>
  </div>
  <div class="grid-x grid-margin-x">
    <div class="cell small-12 medium-6 large-8">
      &nbsp;
    </div>
    <div class="cell small-12 medium-6 large-4">
      @if (invalidDateCombinationMonthlyTracking) {
        <span class="small-font-size red italic">From Date must be less than To Date</span>
      }
    </div>
  </div>
  <ag-grid-angular class="data-grid " [gridOptions]="monthlyTrackingGridOptions" [rowData]="monthlyTrackingGridReportData"   (filterChanged)="onFilterChangedMonthlyTracking($event)" aria-label="Permit Applications Report"></ag-grid-angular>
</div>
<div class="grid-container margin-top">
  <div class="grid-x grid-margin-x">
    <div>
      <h2>Permits Issued Tracking</h2>
    </div>
  </div>
  <div class="grid-x grid-margin-x">
    <div class="cell large-1 small-1 medium-1 text-align-right">
      <label for="fromDate">From:</label>
    </div>
    <div class="cell small-11 medium-5 large-3 date-picker-cell">
      <common-date-picker [id]="'fromDate'" (dateUpdated)="fromDateChanged($event, 'permitsIssuedGrid')" [initialDate]="permitsIssuedTrackingFromDate"></common-date-picker>
    </div>
    <div class="cell large-1 small-1 medium-1 text-align-right">
      <label for="toDate">To:</label>
    </div>
    <div class="cell small-11 medium-5 large-3 date-picker-cell">
      <common-date-picker [id]="'toDate'" (dateUpdated)="toDateChanged($event, 'permitsIssuedGrid')" [initialDate]="permitsIssuedTrackingToDate"></common-date-picker>
    </div>
    <div class="cell small-6 medium-6 large-2 vertical-align-middle">
      <button (click)="generatePemitsIssuedTrackingReport()" [disabled]="invalidDateCombinationPermitsIssued" class="button">
        Filter by Date
      </button>
    </div>
    <div class="cell small-6 medium-6 large-2 text-right vertical-align-middle">
      <button (click)="downloadPermitsIssuedTrackingReport()" class="button" [disabled]="invalidDateCombinationPermitsIssued">
        Download Report
      </button>
    </div>
  </div>
  <div class="grid-x grid-margin-x">
    <div class="cell small-12 medium-6 large-8">
      &nbsp;
    </div>
    <div class="cell small-12 medium-6 large-4">
      @if (invalidDateCombinationPermitsIssued) {
        <span class="small-font-size red italic">From Date must be less than To Date</span>
      }
    </div>
  </div>
  <ag-grid-angular class="data-grid " [gridOptions]="permitsIssuedTrackingGridOptions" [rowData]="permitsIssuedGridReportData"   (filterChanged)="onFilterChangedPermitsIssuedTracking($event)" aria-label="Permit Applications Report"></ag-grid-angular>
</div>
<div class="grid-container margin-top">
  <div class="grid-x grid-margin-x">
    <div>
      <h2>Revenue By Application Type</h2>
    </div>
  </div>
  <div class="grid-x grid-margin-x">
    <div class="cell large-1 small-1 medium-1 text-align-right">
      <label for="fromDate">From:</label>
    </div>
    <div class="cell small-11 medium-5 large-3 date-picker-cell">
      <common-date-picker [id]="'fromDate'" (dateUpdated)="fromDateChanged($event, 'revenueGrid')" [initialDate]="revenueFromDate"></common-date-picker>
    </div>
    <div class="cell large-1 small-1 medium-1 text-align-right">
      <label for="toDate">To:</label>
    </div>
    <div class="cell small-11 medium-5 large-3 date-picker-cell">
      <common-date-picker [id]="'toDate'" (dateUpdated)="toDateChanged($event, 'revenueGrid')" [initialDate]="revenueToDate"></common-date-picker>
    </div>
    <div class="cell small-6 medium-6 large-2 vertical-align-middle">
      <button (click)="generateRevenueReport()" [disabled]="invalidDateCombinationRevenue" class="button">
        Filter by Date
      </button>
    </div>
    <div class="cell small-6 medium-6 large-2 text-right vertical-align-middle">
      <button (click)="downloadRevenueReport()" class="button" [disabled]="invalidDateCombinationRevenue">
        Download Report
      </button>
    </div>
  </div>
  <div class="grid-x grid-margin-x">
    <div class="cell small-12 medium-6 large-8">
      &nbsp;
    </div>
    <div class="cell small-12 medium-6 large-4">
      @if (invalidDateCombinationRevenue) {
        <span class="small-font-size red italic">From Date must be less than To Date</span>
      }
    </div>
  </div>
  <ag-grid-angular class="data-grid " [gridOptions]="revenueGridOptions" [rowData]="revenueGridReportData"  (filterChanged)="onFilterChangedRevenue($event)" aria-label="Permit Applications Report"></ag-grid-angular>
</div>
